export const CONSOLE_RESET_STATE = "CONSOLE_RESET_STATE"
export const CONSOLE_RESET_STATE_SUCCESSFUL = "CONSOLE_RESET_STATE_SUCCESSFUL"
export const CONSOLE_RESET_STATE_FAILED = "CONSOLE_RESET_STATE_FAILED"

export const CONSOLE_COMPANY_LIST = "CONSOLE_COMPANY_LIST"
export const CONSOLE_COMPANY_LIST_SUCCESSFUL =  "CONSOLE_COMPANY_LIST_SUCCESSFUL"
export const CONSOLE_COMPANY_LIST_FAILED = "CONSOLE_COMPANY_LIST_FAILED"

export const CONSOLE_SIGNUP_LIST = "CONSOLE_SIGNUP_LIST"
export const CONSOLE_SIGNUP_LIST_SUCCESSFUL =  "CONSOLE_SIGNUP_LIST_SUCCESSFUL"
export const CONSOLE_SIGNUP_LIST_FAILED = "CONSOLE_SIGNUP_LIST_FAILED"

export const CONSOLE_COPY = "CONSOLE_COPY"
export const CONSOLE_COPY_SUCCESSFUL =  "CONSOLE_COPY_SUCCESSFUL"
export const CONSOLE_COPY_FAILED = "CONSOLE_COPY_FAILED"

export const CONSOLE_SHARE = "CONSOLE_SHARE"
export const CONSOLE_SHARE_SUCCESSFUL =  "CONSOLE_SHARE_SUCCESSFUL"
export const CONSOLE_SHARE_FAILED = "CONSOLE_SHARE_FAILED"

export const CONSOLE_SMS = "CONSOLE_SMS"
export const CONSOLE_SMS_SUCCESSFUL =  "CONSOLE_SMS_SUCCESSFUL"
export const CONSOLE_SMS_FAILED = "CONSOLE_SMS_FAILED"

export const CONSOLE_RESPONSE_RESET_STATE = "CONSOLE_RESPONSE_RESET_STATE"
export const CONSOLE_RESPONSE_RESET_STATE_SUCCESSFUL = "CONSOLE_RESPONSE_RESET_STATE_SUCCESSFUL"
export const CONSOLE_RESPONSE_RESET_STATE_FAILED = "CONSOLE_RESPONSE_RESET_STATE_FAILED"

export const CONSOLE_INVITE_SHARE = "CONSOLE_INVITE_SHARE"
export const CONSOLE_INVITE_SHARE_SUCCESSFUL =  "CONSOLE_INVITE_SHARE_SUCCESSFUL"
export const CONSOLE_INVITE_SHARE_FAILED = "CONSOLE_INVITE_SHARE_FAILED"

export const CONSOLE_INVITE_SMS = "CONSOLE_INVITE_SMS"
export const CONSOLE_INVITE_SMS_SUCCESSFUL =  "CONSOLE_INVITE_SMS_SUCCESSFUL"
export const CONSOLE_INVITE_SMS_FAILED = "CONSOLE_INVITE_SMS_FAILED"

export const CONSOLE_CONNECT = "CONSOLE_CONNECT"
export const CONSOLE_CONNECT_SUCCESSFUL =  "CONSOLE_CONNECT_SUCCESSFUL"
export const CONSOLE_CONNECT_FAILED = "CONSOLE_CONNECT_FAILED"